export default {
      id: "vk-usage",
      viewBox: "0 0 32 32",
      url: "assets/" + "sprite.svg#vk-usage",
      toString: function () {
        return this.url;
      }
    }